import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { first } from 'rxjs/operators';
import { GeneralService } from 'src/app/Service/general.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.scss'],
})
export class EditComponent implements OnInit {
  breadCrumbItems: Array<{}>;
  EPPEdit: FormGroup;
  submitted = false;
  isLoading: boolean;
  currentUser: any;
  constructor(
    private fb: FormBuilder,
    private gs: GeneralService,
    private route: ActivatedRoute,
    private router: Router,
    private datepipe: DatePipe
  ) {}
  columns = ['User Id', 'User Name', 'Group Id'];

  index = ['UserID', 'UserName', 'group_id'];

  users = [];
  baseDocType:any;
  Epp = [];

  ngOnInit() {
    this.currentUser = this.gs.getcurrentUser()
    this.breadCrumbItems = [
      {
        label: 'EPP',
        path: '/',
      },
      {
        label: 'View',
        path: 'view/' + this.route.snapshot.params.UserID,
      },
      { label: 'Edit EPP', path: 'edit/:UserID/:userEPPSubscription', active: true },
    ];
    this.EPPEdit = new FormGroup({
      district: new FormControl('', Validators.required),
      taluka: new FormControl(''),
      village: new FormControl(''),
      survey_number: new FormControl('', Validators.required),
      BaseDocument: new FormControl(null, Validators.required),
      citysurveyoffice: new FormControl(''),
      start_date: new FormControl('', Validators.required),
      end_date: new FormControl('', Validators.required),
      ward: new FormControl(''),
      sheetno: new FormControl(''),
      Admin_ID: new FormControl(this.currentUser.Id)
      // start_date: new FormControl('', Validators.required),
      // end_date: new FormControl('', Validators.required),
    });
    
    this.gs
      .getEppById(this.route.snapshot.params.userEPPSubscription)
      .subscribe((Response: any) => {
        this.Epp = Response.data;

        // this.Epp.map((item) => {
        //   item.start_date = this.datepipe.transform(
        //     item.start_date,
        //     'yyyy-MM-dd'
        //   );
        //   // item.start_date = this.datepipe.transform(
        //   //   item.start_date,
        //   //   'yyyy-MM-dd'
        //   // );
        //   item.end_date = this.datepipe.transform(item.end_date, 'yyyy-MM-dd');
        // });
        this.EPPEdit.patchValue(this.Epp[0]);
        this.EPPEdit.controls.start_date.setValue(this.datepipe.transform(this.Epp[0].start_date,'yyyy-MM-dd'));
        this.EPPEdit.controls.end_date.setValue(this.datepipe.transform(this.Epp[0].end_date,'yyyy-MM-dd'));
        this.baseDocType = this.Epp[0].BaseDocument;
        console.log(this.Epp[0].BaseDocument);
        this.onChangeBaseDocType();
      },(error) => {                              //Error callback
        this.isLoading = false;
        Swal.fire({
          title: error.status,
          text: "Internal Server Error",
          type: "error",
        });
        //throw error;   //You can also throw the error to a global error handler
      });

  }
  get f() {
    return this.EPPEdit.controls;
  }
  onChangeBaseDocType() {
    this.baseDocType = this.EPPEdit.controls.BaseDocument.value;
    if(this.baseDocType === '0') {
      this.EPPEdit.get('taluka').setValidators([Validators.required]);
      this.EPPEdit.get('village').setValidators([Validators.required]);
      this.EPPEdit.get('citysurveyoffice').clearValidators();
      this.EPPEdit.get('ward').clearValidators();
      this.EPPEdit.get('sheetno').clearValidators();
      this.EPPEdit.get('taluka').updateValueAndValidity();  
      this.EPPEdit.get('village').updateValueAndValidity();  
      this.EPPEdit.get('citysurveyoffice').updateValueAndValidity();  
      this.EPPEdit.get('ward').updateValueAndValidity();  
      this.EPPEdit.get('sheetno').updateValueAndValidity();  
    } else if(this.baseDocType === '1') {
      this.EPPEdit.get('citysurveyoffice').setValidators([Validators.required]);
      this.EPPEdit.get('ward').setValidators([Validators.required]);
      this.EPPEdit.get('sheetno').setValidators([Validators.required]);
      this.EPPEdit.get('taluka').clearValidators();
      this.EPPEdit.get('village').clearValidators();
      this.EPPEdit.get('citysurveyoffice').updateValueAndValidity();  
      this.EPPEdit.get('ward').updateValueAndValidity();  
      this.EPPEdit.get('sheetno').updateValueAndValidity();  
      this.EPPEdit.get('taluka').updateValueAndValidity();  
      this.EPPEdit.get('village').updateValueAndValidity();  
    } 
  }
  onSubmit() {
    if(this.baseDocType === '1' && this.EPPEdit.valid) {
      this.EPPEdit.controls.citysurveyoffice.setValue(this.EPPEdit.controls.citysurveyoffice.value.trim());
      this.EPPEdit.controls.ward.setValue(this.EPPEdit.controls.ward.value.trim());
      this.EPPEdit.controls.sheetno.setValue(this.EPPEdit.controls.sheetno.value.trim());
    } else if(this.baseDocType === '0' && this.EPPEdit.valid){
      this.EPPEdit.controls.taluka.setValue(this.EPPEdit.controls.taluka.value.trim());
      this.EPPEdit.controls.village.setValue(this.EPPEdit.controls.village.value.trim());
      
    }
    this.EPPEdit.controls.district.setValue(this.EPPEdit.controls.district.value.trim());
    this.EPPEdit.controls.survey_number.setValue(this.EPPEdit.controls.survey_number.value.trim()); 
    this.submitted = true;
    if (this.EPPEdit.valid) {
      // 1 is Property ID
      console.log(this.EPPEdit);
      this.isLoading = true;
      this.gs
        .UpdateEpp(
          this.route.snapshot.params.UserID,
          this.route.snapshot.params.userEPPSubscription,
          this.EPPEdit.value
        )
        .subscribe((data) => {
          this.isLoading = false;

          if (data.status === 200) {
            this.submitted = false;
            Swal.fire({
              title: 'User EPP Updated',
              text: data.message,
              type: 'success',
            }).then(() => {
              this.submitted = false;
              // this.reFresh.emit();
              this.router.navigate([
                'epp/view/' + this.route.snapshot.params.UserID,
              ]);
            });
          } else {
            Swal.fire({
              title: data.error_code,
              text: data.message,
              type: 'error',
            }).then(() => {
              this.router.navigate(['']);
            });
          }
        },(error) => {                              //Error callback
          this.isLoading = false;
          Swal.fire({
            title: error.status,
            text: "Internal Server Error",
            type: "error",
          });
          //throw error;   //You can also throw the error to a global error handler
        });
    }
  }
}
